import { ThemeProvider } from 'styled-components';
import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { CookiesProvider } from 'react-cookie';

import './App.css';
import { theme } from './styles/styles';
import InputPage from './pages/InputPage';
import LandingPage from './pages/LandingPage/LandingPage';
import Analysis from './pages/AnalysisPage';
import Methodology from './pages/Methodology/Methodology';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import AccessPortal from './components/AccessPortal/AccessPortal';
import { MoonLoader } from 'react-spinners';
import { useSelector, useDispatch } from 'react-redux';
import {
  setShowAccessPortal,
  setInvalidAccessKey,
  setAccessCode,
  setBetaChecked,
} from './features/betaAuth/betaAuth';
import { useLogin } from './hooks/useLogin';
import { LoaderWrapper } from './App.styled';

function App() {
  const { loginAsync, token, isError, isLoading } = useLogin();
  const showAccessPortal = useSelector(
    (state) => state.betaAuth.showAccessPortal,
  );
  const invalidAccessKey = useSelector(
    (state) => state.betaAuth.invalidAccessKey,
  );
  const betaChecked = useSelector((state) => state.betaAuth.betaChecked);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!token && !betaChecked) {
      loginAsync()
        .then((data) => {
          if (data.beta) {
            dispatch(setShowAccessPortal(true));
            dispatch(setBetaChecked(true));
          } else if (data.token) {
            dispatch(setShowAccessPortal(false));
            dispatch(setBetaChecked(true));
          }
        })
        .catch((error) => {
          console.error('Login check failed:', error);
          dispatch(setBetaChecked(true));
        });
    }
  }, [token, betaChecked, dispatch, loginAsync]);

  const handleAccessCodeSubmit = (code) => {
    dispatch(setAccessCode(code));
    dispatch(setInvalidAccessKey(false));

    loginAsync(code)
      .then((data) => {
        if (data.invalidKey) {
          dispatch(setInvalidAccessKey(true));
        } else if (data.token) {
          dispatch(setShowAccessPortal(false));
        }
      })
      .catch((error) => {
        console.error('Beta key validation failed:', error);
        dispatch(setInvalidAccessKey(true));
      });
  };

  if (isLoading) {
    return (
      <LoaderWrapper>
        <MoonLoader color={theme.secondaryColor} />
      </LoaderWrapper>
    );
  }

  if (isError) {
    return (
      <CookiesProvider>
        <ThemeProvider theme={theme}>
          <div className="App">
            <NotFoundPage />
          </div>
        </ThemeProvider>
      </CookiesProvider>
    );
  }

  if (showAccessPortal && !token) {
    return (
      <CookiesProvider>
        <ThemeProvider theme={theme}>
          <div className="App">
            <AccessPortal
              invalidAccessKey={invalidAccessKey}
              onSubmit={handleAccessCodeSubmit}
            />
          </div>
        </ThemeProvider>
      </CookiesProvider>
    );
  }

  return (
    <CookiesProvider>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/input" element={<InputPage />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/methodology" element={<Methodology />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </ThemeProvider>
    </CookiesProvider>
  );
}

export default App;
